module.exports = __webpack_public_path__ + "static/media/Tax.16f1b46d.svg";